import { render, staticRenderFns } from "./LimoAnimation.vue?vue&type=template&id=40f79976&scoped=true&"
import script from "./LimoAnimation.vue?vue&type=script&lang=js&"
export * from "./LimoAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LimoAnimation.vue?vue&type=style&index=0&id=40f79976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f79976",
  null
  
)

export default component.exports